import { render, staticRenderFns } from "./log.vue?vue&type=template&id=4c1dfb4a"
import script from "./log.vue?vue&type=script&lang=ts"
export * from "./log.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports